import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { DispDepositType } from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "返戻金額",
    keyword: "returnAmt",
    type: "amount",
    requiredIcon: true,
    inputProps: { maxLength: 9 },
    disabled: true,
  },
  {
    title: "",
    keyword: "lineTitle",
    type: "lineTitle",
  },
  {
    title: "振込先金融機関",
    keyword: "financialInstitution",
    type: "bankSearch",
    requiredIcon: true,
  },
  {
    title: "金融機関コード",
    keyword: "bankCd",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "金融機関名",
    keyword: "bankName",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "支店コード",
    keyword: "branchCd",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "支店名",
    keyword: "branchName",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "預金種目",
    keyword: "depositType",
    type: "radio",
    radioPropsList: TkGetCodeList(DispDepositType),
    requiredIcon: true,
    disabled: true,
  },
  {
    title: "口座番号",
    keyword: "accountNo",
    type: "label",
    requiredIcon: true,
    inputProps: { maxLength: 7 },
  },
  {
    title: "口座名義人名(半角ｶﾀｶﾅ)",
    keyword: "accountHolderKana",
    type: "label",
    requiredIcon: true,
    hafWidth: true,
    convertToHalfwidth: true,
    convertBankFormat: true,
    inputProps: { maxLength: 20 },
  },
  {
    title: "法人口座（通帳）の写し",
    keyword: "corpAccountCopyFile",
    type: "fileUpload",
    text: "",
    requiredIcon: true,
    id: "corpAccountCopyFileId",
    downloadBase64: true,
  },
];

const schema: any = {
  financialInstitution: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  returnAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 999999999,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "999999999"),
    },
  },
  depositType: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  accountNo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  accountHolderKana: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^([ｱ-ﾝｦ0-9\\(\\)\\.\\-\\/ ]|([-])|([ｳｶ-ﾄﾊ-ﾎ]ﾞ)|([ﾊ-ﾎ]ﾟ))+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    maxLength: {
      value: 21,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "20"),
    },
  },
  corpAccountCopyFile: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
};

const headList: any[] = [
  {
    headTitle: "帳票名",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
  {
    headTitle: "決裁日",
    align: "left",
  },
];

export { fakeTableList, schema, headList };
